// extracted by mini-css-extract-plugin
module.exports = {"newPassAsk":"NewPassAsk_newPassAsk__3wNMA","error":"NewPassAsk_error__5lOA7"};